export const STATUS_SUPPLIER = {
    review: "Pendiente de Revisión por Usuario",
    pending_review: "Pendiente de Revisión por Compras",
    created: "Aprobada",
    incomplete: "Solicitud Incompleta",
    canceled: "Solicitud Cancelada",
}

export const DOCUMENTS_LIST_FORM_STANDARD = [
    {
        id: null,
        key: "declaration",
        name: "Declaración de Vinculo Contratista",
        file: null,
        preview: null,
        new_filename: null,
    },
    {
        id: null,
        key: "model_prevention",
        name: "Cumplimiento de Modelo de Prevención del Delito",
        file: null,
        preview: null,
        new_filename: null,
    },
    {
        id: null,
        key: "certificate_bank",
        name: "Certificado de Antigüedad Bancario o Carta de Transferencia Bancaria Notariada",
        file: null,
        preview: null,
        new_filename: null,
    },
    {
        id: null,
        key: "general_conditions",
        name: "Condiciones Generales",
        file: null,
        preview: null,  
        new_filename: null,
    },

    // NUEVO CAMPO OBLIGATORIO
    {
        id: null,
        key: "society_certificate",
        name: "Certificado de vigencia de la sociedad",
        file: null,
        preview: null,  
        new_filename: null,
    }

    
]